import Nav from "./components/Nav";
import Hero from "./components/Hero";
import SceneStream from "./components/SceneStream";
import BuzzWall from "./components/BuzzWall";
import RankBoard from "./components/RankBoard";
import HowTo from "./components/HowTo";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

const TICKER = [
  "黑料色动图今日已上新 96 段",
  "高能反转场景新增录屏回放 21 段",
  "神回复现场表情包正在补货",
  "名场面台词切片 10 分钟内持续入库",
  "直播回放支持进度卡位",
  "今日热榜每 10 分钟刷新一次",
];

export default function Home() {
  return (
    <main className="w-full bg-background-50 font-sans">
      <Nav />
      <Hero />

      {/* 运营跑马灯 */}
      <div className="w-full overflow-hidden border-y border-background-200 bg-background-100/60 py-3">
        <div className="marquee-track">
          {[0, 1].map((g) => (
            <div key={g} aria-hidden={g === 1} className="flex shrink-0 items-center">
              {TICKER.map((t) => (
                <span
                  key={`${g}-${t}`}
                  className="flex items-center gap-2 whitespace-nowrap px-6 text-xs text-foreground-500"
                >
                  <i className="ri-flashlight-fill text-accent-600" />
                  {t}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>

      <SceneStream />
      <BuzzWall />
      <RankBoard />
      <HowTo />
      <Faq />
      <Footer />
    </main>
  );
}